// extracted by mini-css-extract-plugin
export var card_top_tips = "index-module--card_top_tips--3a93d";
export var custom = "index-module--custom--ddc45";
export var pro = "index-module--pro--55f91";
export var team = "index-module--team--c7260";
export var team_tips = "index-module--team_tips--597ae";